module.exports = __webpack_public_path__ + "img/interior_2.820ca8fd.jpg";